import styled from 'styled-components';

export const ErrorContainer = styled('div')`
	flex: 1;
	margin: 1.4rem 0rem ;
	.warning{
		color: #ffcc00;
	}
	.error{
		color: #cc3300;
	}
	p{
		font: 400 1.2rem Archivo;
	}
`;
